"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/NewMessagesMarker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






 const newMessagesLabel = (count) =>
  count === 1 ? '1 new message' : `${count} new messages`; exports.newMessagesLabel = newMessagesLabel

const NewMessagesMarker = ({ count, ...props }) => (
  _react2.default.createElement('div', { className: "conversation-box--new-messages-marker", ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
    , _react2.default.createElement('span', { className: "conversation-box--new-messages-marker--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
      ,  exports.newMessagesLabel.call(void 0, count) 
    )
  )
)

exports. default = NewMessagesMarker
